
import DeviceMember from './DeviceMember'
import historyList from './historyList'
import {
setdevicenotify,
setdevicenotifytype,
updatedevice,
deldevice,
setdevice,
calldeicevideo
} from '../../api/device'
import childDevice902 from './childDevice902'
import alarmList from './alarmList'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import childDevice901 from './childDevice901'
import voiceRecordList from './voiceRecordList'
import childDevice7006 from './childDevice7006'
import device507 from './device507'
export default {
name: 'NewChildList',
directives: {TransferDom},
components: {DeviceMember, historyList, Checker, CheckerItem, childDevice902, alarmList, childDevice901, voiceRecordList, childDevice7006, device507},
data () {
return {
isNoOtherShare: true,
isColor: true,
deviceData: {},

openAlarm: false,
closeAlarm: false,
showChild: true,
delOut: false,

editOut: false,
editSuc: false,
editErr: false,
editText: '编辑成功',
editName: '',
editAddress: '',

editChild: false,
editChildName: '',
editId: '',

delChildOut: false,
id: '',
childName: '',
imgArr: [
{dtype: 700, imgUrl: 'static/newDeviceIcon/index_gateway.png'}, // 智能网关
{dtype: 701, imgUrl: 'static/newDeviceIcon/index_gateway.png'}, // 智能网关
{dtype: 400, imgUrl: 'static/newDeviceIcon/index_lock.png'}, // 门锁
{dtype: 300, imgUrl: 'static/newDeviceIcon/index_smoke.png'}, // nb烟感
{dtype: 99, imgUrl: 'static/newDeviceIcon/index_smoke.png'}, // nb烟感
{dtype: 200, imgUrl: 'static/newDeviceIcon/index_police.png'}, // 一键报警
{dtype: 501, imgUrl: 'static/newDeviceIcon/index_CO.png'}, // 一氧化碳
{dtype: 502, imgUrl: 'static/newDeviceIcon/index_gas.png'}, // 燃气
{dtype: 800, imgUrl: 'static/newDeviceIcon/index_police_gateway.png'}, // 一键报警网关
{dtype: 503, imgUrl: 'static/newDeviceIcon/index_fire.png'}, // 灭火器压力表
{dtype: 504, imgUrl: 'static/newDeviceIcon/index_door_sensor.png'}, // NB门磁
{dtype: 505, imgUrl: 'static/newDeviceIcon/index_SOS_btn.png'}, // NB-SOS按钮 巡鹰
{dtype: 506, imgUrl: 'static/newDeviceIcon/index_smoke.png'}, // NB-烟感新
{dtype: 507, imgUrl: 'static/newDeviceIcon/index_SOS_btn.png'}, // NB-SOS按钮 西美
{dtype: 901, imgUrl: 'static/newDeviceIcon/index_W23.png'}, // Cat1 W23
{dtype: 902, imgUrl: 'static/newDeviceIcon/index_701SE.png'}, // Cat1 拉绳报警器
{dtype: '', imgUrl: 'static/newDeviceIcon/index_default.png'} // 默认
],
iconArr: [

{dtype: -1, imgUrl: '../../../static/newDeviceIcon/second_alarmlamp.png'}, // 警灯
{dtype: 1, imgUrl: '../../../static/newDeviceIcon/index_CO.png'}, // 一氧化碳
{dtype: 2, imgUrl: '../../../static/newDeviceIcon/index_humiture_smoke.png'}, // 烟感
{dtype: 3, imgUrl: '../../../static/newDeviceIcon/index_gas.png'}, // 燃气
{dtype: 4, imgUrl: '../../../static/newDeviceIcon/second_door.png'}, // 门磁
{dtype: 5, imgUrl: '../../../static/newDeviceIcon/second_doorbell.png'}, // 门铃
{dtype: 6, imgUrl: '../../../static/newDeviceIcon/second_red.png'}, // 红外
{dtype: 7, imgUrl: '../../../static/newDeviceIcon/second_water.png'}, // 水浸
{dtype: 8, imgUrl: '../../../static/newDeviceIcon/second_control.png'}, // 遥控器
{dtype: 11, imgUrl: 'static/newDeviceIcon/index_humiture_smoke.png'}, // 温湿度烟感
{dtype: 12, imgUrl: 'static/newDeviceIcon/index_water.png'}, // 水压
{dtype: 13, imgUrl: 'static/newDeviceIcon/index_level.png'}, // 水位
{dtype: 51, imgUrl: 'static/newDeviceIcon/index_socket.png'}, // 智能开关
{dtype: 52, imgUrl: 'static/newDeviceIcon/index_humiture.png'}, // 温湿度
{dtype: 53, imgUrl: '../../../static/newDeviceIcon/second_lamp.png'}, // 智能灯泡
{dtype: 14, imgUrl: '../../../static/newDeviceIcon/second_door.png'}, // 门磁

{dtype: '', imgUrl: '../../../static/newDeviceIcon/second_default.png'} // 15
],
childData: [],

study: false,
sharePhone: '',
shareData: {},
shareToast: false,
shareIsg: '请输入手机号',
isShare: false,
showAdd: false,
addText: '添加成功啦~',
addWarn: false,
warnText: '',
etime: 0,
childType: [2, 12, 13, 52, 11, 14],
selectTitle: 1,

resultWay: [],
callHint: false,
unhandlAlarmShow: false, // 未处理弹窗

setting: {},
selectItem: '',
activeShow: false,
activeValVan: false,
showDisabled: true,
showHint: false,
hintText: '第二个字段要么为0，要么大于第一个字段值。',
value1: '',
showPicker1: false,
valueIndex1: 0,
clockContentArr1: [{text: 0}, {text: 1}, {text: 2}, {text: 3}, {text: 4}, {text: 5}, {text: 6}, {text: 7}, {text: 8}, {text: 9}, {text: 10}, {text: 11}, {text: 12},
{text: 13}, {text: 14}, {text: 15}, {text: 16}, {text: 17}, {text: 18}, {text: 19}, {text: 20}, {text: 21}, {text: 22}, {text: 23}],
value2: '',
showPicker2: false,
valueIndex2: 0,
clockContentArr2: [{text: 0}, {text: 10}, {text: 20}, {text: 30}, {text: 40}, {text: 50}],
value3: '',
showPicker3: false,
valueIndex3: 0,
clockContentArr3: [{text: 0}, {text: 1}, {text: 2}, {text: 3}, {text: 4}, {text: 5}, {text: 6}, {text: 7}, {text: 8}, {text: 9}, {text: 10}, {text: 11}, {text: 12},
{text: 13}, {text: 14}, {text: 15}, {text: 16}, {text: 17}, {text: 18}, {text: 19}, {text: 20}, {text: 21}, {text: 22}, {text: 23}],
value4: '',
showPicker4: false,
valueIndex4: 0,
clockContentArr4: [{text: 0}, {text: 1}, {text: 2}, {text: 3}, {text: 4}, {text: 5}, {text: 6}, {text: 7}, {text: 8}, {text: 9}, {text: 10}, {text: 11}, {text: 12},
{text: 13}, {text: 14}, {text: 15}, {text: 16}, {text: 17}, {text: 18}, {text: 19}, {text: 20}, {text: 21}, {text: 22}, {text: 23}]
}
},
created () {
this.etime = Date.parse(new Date())

Date.prototype.format = this.validate.format
this.deviceData = this.$store.getters.get_child_obj
console.log('deviceData', this.deviceData)
this.editName = this.deviceData.name
this.editAddress = this.deviceData.address

if (this.deviceData.dtype === 400 || this.deviceData.dtype === 700 || this.deviceData.dtype === 701 || this.deviceData.dtype === 800) {
this.getChildList()
this.selectTitle = 0
} else if (this.deviceData.dtype === 504) {
if (this.deviceData.phonedevicerole === 'admin') {
this.showDisabled = false
} else {
this.showDisabled = true
}
if (this.deviceData.setting !== null && this.deviceData.setting !== '' && this.deviceData.setting.length > 0) {
for (let i = 0; i < this.deviceData.setting.length; i++) {
if (this.deviceData.setting[i].func === 'isactivity') {
this.setting = this.clone(this.deviceData.setting[i])
if (this.setting.other && this.setting.other !== '') {
this.setting.other = JSON.parse(this.setting.other)
}
this.changeTimeShow(this.setting)
}
}
}
/* 开门提醒 2 关门提醒 3 全部提醒 1 关闭提醒 0 */
this.selectTitle = 1
this.deviceData.showOpen = 0
this.deviceData.showClose = 0
if (this.deviceData.notify === 0) {
this.deviceData.showOpen = 0
this.deviceData.showClose = 0
} else if (this.deviceData.notify === 1) {
this.deviceData.showOpen = 1
this.deviceData.showClose = 1
} else if (this.deviceData.notify === 2) {
this.deviceData.showOpen = 1
this.deviceData.showClose = 0
} else if (this.deviceData.notify === 3) {
this.deviceData.showOpen = 0
this.deviceData.showClose = 1
}
if (this.deviceData.showOpen === 0) {
this.openAlarm = false
} else {
this.openAlarm = true
}
if (this.deviceData.showClose === 0) {
this.closeAlarm = false
} else {
this.closeAlarm = true
}
if (this.deviceData.showOpen === 0 && this.deviceData.showClose === 0) {
this.showWay = false
}






this.resultWay = []
let notifytype = this.deviceData.notifytype.split('')
if (notifytype[0] === '1') {
this.resultWay.push('1')
}
if (notifytype[1] === '1') {
this.resultWay.push('2')
}
if (notifytype[2] === '1') {
this.resultWay.push('3')
}

} else if (this.deviceData.dtype === 902) {
this.isColor = false
this.selectTitle = 4
} else if (this.deviceData.dtype === 507) {
this.selectTitle = 8
} else {
this.selectTitle = 3
}
if (this.deviceData.phonedevicerole === 'normal' || this.deviceData.phonedevicerole === '' || this.deviceData.phonedevicerole === 'familyshare') { // 成员分享

}
this.golobleObject.getMqttDoor = this.changeDoorStatus
document.getElementsByTagName('title')[0].innerText = '设备详情'
},
mounted () {
document.getElementsByTagName('title')[0].innerText = '设备详情'
},
beforeDestroy () {
document.getElementsByTagName('title')[0].innerText = '智慧安防'
},
methods: {
getFatherEvent901 () {},


openVideo () {
let data = {
deviceid: this.deviceData.deviceid,
name: this.deviceData.name,
videotype: 'video' 
}
calldeicevideo(data).then(res => {



location.assign('https://rtc.sdyit.com/websrs/?autostart=true&room=' + res.data.roomid)
}).catch(() => {
this.$toast.fail('失败')
})


},
getFatherEvent (phone) {
this.deviceData.devicephone = phone
},
change (val, label) {
console.log('change', val, label)
},
changeDoorStatus (obj) {
if (obj.device_id === this.deviceData.deviceid) {
this.deviceData.unhandlealarm += 1
if (obj.alarmtype === 'doorclose') {
this.deviceData.doorStatus = '关门'
} else if (obj.alarmtype === 'dooropen') {
this.deviceData.doorStatus = '开门'
}
}
},
getOpenClose (config) {
let name = ''
if (config.passthrough) {
let num = config.passthrough + ''
let val = num.slice(0, 1)
if (val === '0') {
name = '关门'
} else if (val === '1') {
name = '开门'
}
}
return name
},
openTitleSelect (index) {
this.selectTitle = index
},

getMPaName (pressure) {
return pressure / 1000000
},

getLevelName (level) {
return level / 100
},
isPhone () {
const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
if (this.sharePhone === '') {
this.isShare = true
this.shareIsg = '请输入手机号'
} else if (!reg.test(this.sharePhone)) {
this.isShare = true
this.shareIsg = '手机号格式错误'
} else {
this.isShare = false
}
},
sendShare () {
const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
if (this.sharePhone === '') {
this.isShare = true
this.shareIsg = '请输入手机号'
return
} else if (!reg.test(this.sharePhone)) {
this.isShare = true
this.shareIsg = '手机号格式错误'
return
}
let item = this.shareData
this.$http.post(this.base + 'sharedevice?token=' + this.$store.getters.get_token, {did: item.id,
phone: this.sharePhone,
role: 'normal'}).then(res => {
this.shareToast = false
if (res.data.code === 200) {

this.showAdd = true
this.addText = '共享成功'
} else {
this.addWarn = true
this.warnText = '共享失败'
}
}).catch(() => {
this.addWarn = true
this.warnText = '共享失败'
})
},
getImageUrl () {
let key = parseInt(this.deviceData.dtype)
let imgdata = this.imgArr
let img = ''
for (let i = 0; i < imgdata.length; i++) {
if (imgdata[i].dtype === key) {
img = imgdata[i].imgUrl
}
}
if (img === '') {
return imgdata[this.imgArr.length - 1].imgUrl
} else {
return img
}
},

delDevice (id) {
let data = {
dids: [parseInt(id)]
}
deldevice(data).then(res => {
if (res.code === 200) {
this.delOut = false
this.$router.push('/Device')
} else {
this.editText = res.data.msg
this.editErr = true
}
}).catch(() => {
this.editText = '失败'
this.editErr = true
})
},

commitEdit () {








let data = {
did: parseInt(this.deviceData.id),
name: this.editName,
devicephone: this.deviceData.devicephone,
address: this.editAddress
}
updatedevice(data).then(res => {
if (res.code === 200) {
this.editSuc = true
this.editOut = false
this.deviceData.name = this.editName
this.deviceData.address = this.editAddress
} else {
this.editText = res.data.msg
this.editErr = true
}
}).catch(() => {
this.editText = '失败'
this.editErr = true
})
},

editFun (id, name) {
this.editChild = true
this.editChildName = name
this.editId = id
},
editCommit () {
this.$http.post(this.base + 'editdevicesub?token=' + this.$store.getters.get_token, {did: this.editId, name: this.editChildName, pid: parseInt(this.deviceData.id)}).then(res => {
if (res.data.code === 200) {
this.editChild = false
this.editSuc = true
this.getChildList()
} else {
this.editText = res.data.msg
this.editErr = true
}
}).catch(() => {
this.editText = '编辑失败'
this.editErr = true
})
},
delChildDevice () {
this.$http.post(this.base + 'deldevicesub?token=' + this.$store.getters.get_token,
{did: parseInt(this.id), pid: parseInt(this.deviceData.id)}).then(res => {
if (res.data.code === 200) {
this.delChildOut = false
this.editText = '删除成功'
this.editSuc = true
this.getChildList()
} else {
this.editText = res.data.msg
this.editErr = true
}
}).catch(() => {
this.editText = '删除失败'
this.editErr = true
})
},

getChildList () {
this.childData = []
this.$http.post(this.base + 'getsubdevice?token=' + this.$store.getters.get_token, {did: parseInt(this.deviceData.id)}).then(res => {
this.etime = Date.parse(new Date())
if (res.data.code === 200) {
if (res.data.data.length === 0) {
this.showChild = false
} else {
for (let i = 0; i < res.data.data.length; i++) {
let obj = res.data.data[i]
obj.isShow = false
obj.status = this.getSubDeviceStatus(res.data.data[i])
if (res.data.data[i].config !== '') {
obj.config = JSON.parse(res.data.data[i].config)
while (typeof obj.config === 'string') {
obj.config = JSON.parse(obj.config)
}
}
this.$set(this.childData, this.childData.length, obj)
}

}
} else {
this.showChild = true
}
}).catch(() => {})
},

getSubDeviceStatus (item) {




if (this.childType.indexOf(item.dtype) > -1) {

const stime = new Date(item.hearttime.replace(/-/g, '/')).getTime()
const etime = new Date().getTime()
const usedTime = etime - stime
const hours = Math.floor(usedTime / (3600 * 1000))
if (hours < 48) {
return 1
} else {
return 0
}
} else {
return 2
}
},

getModelName (model) {
if (model !== 'zyzigbee') {
let arr = model.split('')
if (arr[arr.length - 1]) {
if (arr[arr.length - 1] === 'F') {

return '智慧型'
} else if (arr[arr.length - 1] === 'A') {

return '普通型'
}
}
} else {
return model
}
},
getModelNameShow (model) {
if (model !== 'zyzigbee') {
let arr = model.split('')
if (arr[arr.length - 1]) {
if (arr[arr.length - 1] === 'F') {
return true
} else if (arr[arr.length - 1] === 'A') {
return true
}
}
} else {
return true
}
},
getModelNameClass (model, status) {
if (status === 0) {
return 'model-left-level'
} else {
if (model !== 'zyzigbee') {
let arr = model.split('')
if (arr[arr.length - 1]) {
if (arr[arr.length - 1] === 'F') {
return 'model-left-f'
} else if (arr[arr.length - 1] === 'A') {
return 'model-left-a'
}
}
} else {
return 'model-left-z'
}
}
},

getImgUrl (type) {
let key = parseInt(type)
let imgdata = this.iconArr
let aa = true
for (let i = 0; i < imgdata.length; i++) {
if (imgdata[i].dtype === key) {
aa = false
return imgdata[i].imgUrl
}
}
if (aa) {
return imgdata[this.iconArr.length - 1].imgUrl
}
},

addstudy () {
let vm = this
this.study = true
let did = parseInt(this.deviceData.id)
this.$http.post(this.base + 'sendcommand?token=' + this.$store.getters.get_token, {did: did, cmd: 'addsub'}).then(res => {

if (res.data.code === 200) {
vm.study = false
vm.editSuc = true
vm.editText = '添加成功'
}
}).catch(() => {})
},

lockaddstudy () {
let vm = this
this.study = true
let did = parseInt(this.deviceData.id)
this.$http.post(this.base + 'sendcommandlock?token=' + this.$store.getters.get_token, {did: did, cmd: 'lean433', value: '0'}).then(res => {

if (res.data.code === 200) {
vm.study = false
vm.editSuc = true
vm.editText = '添加成功'
}
}).catch(() => {})
},

getChildSwitch (val) {
if (val === '1') {
return '开启'
} else {
return '关闭'
}
},
sendZigbee (item, val) {

if (item.status === 0) {
return
}
let value = {status: val}

this.$http.post(this.base + 'sendcommandnewsub?token=' + this.$store.getters.get_token, {
did: item.pid, subid: item.device_id, iszigbee: item.config.iszigbee, value: JSON.stringify(value)
}).then(res => {
if (res.data.code === 200) {
this.showAdd = true
this.addText = '成功'
this.getChildList()
} else {
this.addWarn = true
this.warnText = '失败'
}
}).catch(() => {
this.addWarn = true
this.warnText = '失败'
})
},
openSubDevice (item) {
if (item.dtype === 2 ||
item.dtype === 11 ||
item.dtype === 12 ||
item.dtype === 13 ||
item.dtype === 51 ||
item.dtype === 52) {
this.$store.commit('set_sub_device', item)
this.$router.push('/secondView')
}
},
changeOpen (val) {
if (this.openAlarm) {
this.deviceData.showOpen = 1
} else {
this.deviceData.showOpen = 0
}
this.changeNBDefence('showOpen')
},
changeClose (val) {
if (this.closeAlarm) {
this.deviceData.showClose = 1
} else {
this.deviceData.showClose = 0
}
this.changeNBDefence('showClose')
},
changeNBDefence (type) {
let data = {did: this.deviceData.id, notify: 0}
if (this.deviceData.showOpen === 0 && this.deviceData.showClose === 0) {
data.notify = 0 
} else if (this.deviceData.showOpen === 1 && this.deviceData.showClose === 1) {
data.notify = 1 
} else if (this.deviceData.showOpen === 1 && this.deviceData.showClose === 0) {
data.notify = 2 
} else {
data.notify = 3 
}
setdevicenotify(data).then(res => {
if (res.code === 200) {
this.showAdd = true
this.addText = '成功'
this.deviceData.notify = data.notify
} else {
this.addWarn = true
this.warnText = '失败'
if (type === 'showOpen') {
if (this.deviceData.showOpen === 0) {
this.deviceData.showOpen = 1
this.openAlarm = true
} else {
this.deviceData.showOpen = 0
this.openAlarm = false
}
} else {
if (this.deviceData.showClose === 0) {
this.deviceData.showClose = 1
this.closeAlarm = true
} else {
this.deviceData.showClose = 0
this.closeAlarm = false
}
}
}
if (this.deviceData.showOpen === 0 && this.deviceData.showClose === 0) {
this.showWay = false
} else {
this.showWay = true
}
this.$store.commit('set_child_obj', this.deviceData)
}).catch(() => {
this.addWarn = true
this.warnText = '布防失败'
if (data.notify === 0) {
this.deviceData.notify = 1
} else {
this.deviceData.notify = 0
}
})
},

changeWaySend () {

let way = '000'
let notifytype = this.deviceData.notifytype
for (let i = 0; i < this.resultWay.length; i++) {
if (this.resultWay[i] === '1') {
way = '1' + way.slice(1)
} else if (this.resultWay[i] === '2') {
way = way.slice(0, 1) + '1' + way.slice(2)
} else if (this.resultWay[i] === '3') {
way = way.slice(0, 2) + '1'
}
}
notifytype = way + notifytype.slice(3)
let data = {
phone: this.$store.getters.get_user,
did: this.deviceData.id,
notifytype
}

setdevicenotifytype(data).then(res => {
if (res.code === 200) {
this.deviceData.notifytype = data.notifytype
this.showAdd = true
this.addText = '成功'

} else {
this.addWarn = true
this.warnText = '失败'
let wayArr = []
let notifytype = this.deviceData.notifytype.split('')
if (notifytype[0] === '1') {
wayArr.push('1')
}
if (notifytype[1] === '1') {
wayArr.push('2')
}
if (notifytype[2] === '1') {
wayArr.push('3')
}
this.resultWay = wayArr
}
}).catch(() => {
let wayArr = []
let notifytype = this.deviceData.notifytype.split('')
if (notifytype[0] === '1') {
wayArr.push('1')
}
if (notifytype[1] === '1') {
wayArr.push('2')
}
if (notifytype[2] === '1') {
wayArr.push('3')
}
this.resultWay = wayArr
this.addWarn = true
this.warnText = '失败'
})

},

editOpenName () {
if (this.deviceData.phonedevicerole === 'normal' || this.deviceData.phonedevicerole === '' || this.deviceData.phonedevicerole === 'familyshare') { // 成员分享
} else {
this.editName = this.deviceData.name
this.editAddress = this.deviceData.address
this.editOut = true
}
},
openAlarmList () {
if (this.deviceData.unhandlealarm > 0) {
this.unhandlAlarmShow = true
}
},
getFatherChange (num) {
let val = this.deviceData.unhandlealarm - num
if (val > 0) {
this.deviceData.unhandlealarm = val
} else {
this.deviceData.unhandlealarm = 0
}
this.$store.commit('set_child_obj', this.deviceData)
},

openActive () {
this.changeTimeShow(this.setting)
this.itemActive = this.selectItem
this.activeShow = true
},
changeTimeShow (setting) {

if (setting !== null && setting.other && setting.other !== '') {
this.activeValVan = true
let value = setting.value
let sTime = parseInt(value)
let mTime = 0
let hTime = 0
if (sTime > 60) {
mTime = parseInt(sTime / 60)
sTime = parseInt(sTime % 60)
if (mTime > 60) {
hTime = parseInt(mTime / 60)
mTime = parseInt(mTime % 60)
}
}
this.value1 = hTime
this.value2 = mTime
this.value3 = parseInt(setting.other.begintime.split(':')[0])
this.value4 = parseInt(setting.other.endtime.split(':')[0])
for (let i = 0; i < this.clockContentArr1.length; i++) {
if (parseInt(this.value1) === this.clockContentArr1[i].text) {
this.valueIndex1 = i
}
if (parseInt(this.value3) === this.clockContentArr1[i].text) {
this.valueIndex3 = i
}
if (parseInt(this.value4) === this.clockContentArr1[i].text) {
this.valueIndex4 = i
}
}
for (let i = 0; i < this.clockContentArr2.length; i++) {
if (parseInt(this.value2) === this.clockContentArr2[i].text) {
this.valueIndex2 = i
}
}
} else {
this.activeValVan = false
}
},
changeActiveVal (val) {
console.log(val)
this.activeValVan = val
},
activeSelectNew () {
this.showHint = false


let val = '0'
let time = ''
let val3 = ''
let val4 = ''
if (this.activeValVan) {
if (this.value1 === '') {
this.showHint = true
this.hintText = '请选择监测周期。'
return
}
if (this.value3 === '' || this.value4 === '') {
this.showHint = true
this.hintText = '请选择监测时段。'
return
}
if (this.value2 !== '') {
time = parseInt(this.value1) * 3600 + parseInt(this.value2) * 60
} else {
time = parseInt(this.value1) * 3600
}
if (parseInt(this.value3) < 10) {
val3 = '0' + this.value3 + ':00'
} else {
val3 = this.value3 + ':00'
}
if (parseInt(this.value4) < 10) {
val4 = '0' + this.value4 + ':00'
} else {
val4 = this.value4 + ':00'
}
val = time + '###' + val3 + '###' + val4
}
let data = {dids: [this.deviceData.id], properties: [{key: 'isactivity', value: val}]}
setdevice(data).then(res => {
if (res.code === 200) {
if (val === '0') {
this.setting.other = ''
this.setting.value = '0'
} else {
let obj = {begintime: val3, endtime: val4}
this.setting.other = obj
this.setting.value = time + ''
}

let obj = {begintime: val3, endtime: val4}
if (this.deviceData.setting !== null && this.deviceData.setting !== '' && this.deviceData.setting.length > 0) {
for (let i = 0; i < this.deviceData.setting.length; i++) {
if (this.deviceData.setting[i].func === 'isactivity') {
this.deviceData.setting[i].value = val === '0' ? '0' : time + ''
this.deviceData.setting[i].other = val === '0' ? '' : JSON.stringify(obj)
}
}
} else {
this.deviceData.setting = []
let aa = {
confirmon: '',
func: 'isactivity',
other: val === '0' ? '' : JSON.stringify(obj),
seton: '',
status: 0,
value: val === '0' ? '0' : time + ''
}
this.deviceData.setting.push(aa)
}
this.$store.commit('set_child_obj', this.deviceData)
this.showAdd = true
this.addText = '成功'
this.selectItem = this.itemActive
this.activeShow = false
} else {
this.addWarn = true
this.warnText = '失败'
}
}).catch(() => {
this.addWarn = true
this.warnText = '失败'
this.activeShow = false
})
},
onConfirm1 (obj) {
this.value1 = obj.text
this.showPicker1 = false
},
onConfirm2 (obj) {
this.value2 = obj.text
this.showPicker2 = false
},
onConfirm3 (obj) {
this.value3 = obj.text
this.showPicker3 = false
},
onConfirm4 (obj) {
this.value4 = obj.text
if (this.value4 !== 0 && this.value4 < this.value3) {
this.showHint = true
this.hintText = '第二个监测时段要么为0时，要么大于第一个监测时段。'
this.value4 = ''
}
this.showPicker4 = false
}
}
}



// WEBPACK FOOTER //
// ./src/components/device/NewChildList.vue